import { render, staticRenderFns } from "./ListProduct.vue?vue&type=template&id=9bdc65fc&scoped=true&"
import script from "./ListProduct.vue?vue&type=script&lang=ts&"
export * from "./ListProduct.vue?vue&type=script&lang=ts&"
import style0 from "./ListProduct.vue?vue&type=style&index=0&id=9bdc65fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdc65fc",
  null
  
)

export default component.exports